import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "@/redux/slices/userSlices";
import btn_option_thaydau from "@/assets/btn_option_thaydau.png";
import btn_option_suppervoucher from "@/assets/btn_option_suppervoucher.png";

const Manager: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onClickOptionThayDau = () => {
    navigate("/Manage/PhieuThayDau");
  };
  const onClickOptionSupervoucher = () => {
    navigate("/Manage/SuperVoucher");
  };

  return (
    <>
      <div className="manager-container relative mb-36 min_h_auto">
        <div className="w-[80%] py-4 flex justify-between items-center gap-4 px-4 mx-auto">
          <img
            src={btn_option_thaydau}
            className="w-[48%] cursor-pointer"
            alt="Cloud 2"
            onClick={onClickOptionThayDau}
          />
          <img
            src={btn_option_suppervoucher}
            className="w-[48%] cursor-pointer"
            alt="Cloud 2"
            onClick={onClickOptionSupervoucher}
          />
        </div>
        <div className="flex gap-4 justify-center">
          <Link to={"/Manage/ChangePassword"} className="check-time-activated">
            Đổi mật khẩu
          </Link>
          <button className="logout" onClick={() => dispatch(logout())}>
            Đăng Xuất
          </button>
        </div>
      </div>
    </>
  );
};
export default Manager;
